import { FormState } from "./newsletterFormBlockState";

export const submitForm = async (data: FormState) => {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  const body = JSON.stringify(data)
  const response = await fetch('/api/v1/Newsletter/SignUp', { method: 'POST', headers, body });

  return response.ok
}